import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild} from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { OrderDetailService } from '../order-detail.service';
import { OrderDetail } from '../order-detail';
import { OrderDetailComponent } from '../order-detail/order-detail.component';
import { ReservationLedgerListComponent } from '../../../reservation-ledger/reservation-ledger-list/reservation-ledger-list.component';
import { OrderDetailTaxListComponent } from '../../order-detail-tax/order-detail-tax-list/order-detail-tax-list.component';
import { ReservationService } from '@app/_components/reservation/reservation.service';
import { TravelAgentProfileService } from '@app/_components/travel-agent-profile/travel-agent-profile.service';
import * as moment from 'moment';
import { Router } from '@angular/router';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from "@angular/forms";
import {ImportExportComponent} from "@app/_components/_helpers/import-export/import-export.component";

@Component({
    selector: 'app-order-detail-list',
    templateUrl: './order-detail-list.component.html',
    styleUrls: ['./order-detail-list.component.css'],
    providers: [MessageService, ConfirmationService],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class OrderDetailListComponent implements OnInit {
	grandTotalAmount: any;
	amountReceived: any;
	reGenerateInvoicePopUp = false;
	addTravelAgentFeePopUp = false;
	compositePasswordDialogVisible = false;
	compositePasswordValue = '';
	compositePasswordError = '';
	private pendingCompositeAction: ((password: string) => void) | null = null;
	formTravelAgent: UntypedFormGroup;

	// Travel Agent Fee dialog state
	travelAgentProfiles: any[] = [];
	travelAgentProfilesLoading = false;
	selectedTravelAgent: any = null;
	taFeeMode: 'pct' | 'amt' = 'pct';
	taFeeBase: 'grandTotal' | 'subTotal' | 'nightlyOnly' = 'grandTotal';
	taAgentPCT: number = 0;
	taAgentAMT: number = 0;
	taPrivateNotes: string = '';
	taComputedAmt: number = 0;
	existingTravelAgentFee: any = null;

	@ViewChild(ImportExportComponent) importExportComponent: ImportExportComponent;
	constructor(
		private orderDetailService: OrderDetailService,
		private reservationService: ReservationService,
		private travelAgentProfileService: TravelAgentProfileService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private router: Router,
		private dialog: MatDialog,
		private formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any
	) {
		this.statuses = orderDetailService.statuses
		this.orderDetails = [];
		if(data){
			this.reservationId = data.reservationId
			this.shortTermRentalId = data.shortTermRentalId
			this.orderId = data.orderId
			this.ruReservationId = data.ruReservationId
		}
	}



	// data
	orderDetails: any;
	@Input() showPagination = true;
	@Input() reservationId: any;
	@Input() checkInDate: any;
	@Input() checkOutDate: any;
	@Input() shortTermRentalId: any;
	@Input() orderId: any;
	@Input() ruReservationId: any;
	@Input() listingType: number = 0;
	@Output() refreshOrder = new EventEmitter<any>();
	opsNoteDetails = [];

	orderDetail: OrderDetail;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	//Show dialog for OpsNotes with Rate Details calculations
	showOpsNoteDialog: boolean = false;

	columns: any[] = [
		{ field: 'name', header: 'Description',  width: 'auto' },
		{ field: 'quantity', header: '#', width: 'auto' },
		{ field: 'listPrice', header: 'Price ', width: 'auto' },
		{ field: 'listPriceAdjustmentAmount', header: '$ Discount ', width: 'auto' },
		{ field: 'subTotal', header: 'SubTotal', width: 'auto' },
		{ field: 'tax', header: 'Tax', width: 'auto' },
		{ field: 'total', header: 'Total', width: 'auto' },
	];
	
	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'orderProductVO.orderProductId', order: 1 });
			// this.findNightlyRateOpsNotesDetails();
			this.buildForm()
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/**
	 * Find the Ops Notes for nightly rate calculated form YieldMax Portal based on 
	 * CheckInDate, CheckOutDate and ShortTermRentalId
	 */
	findNightlyRateOpsNotesDetails()
	{
		this.opsNoteDetails = [];
		if(this.shortTermRentalId != null && this.checkInDate != null && this.checkOutDate != null)
		{
			try {
				// this.formLoading = true;
				this.showOpsNoteDialog = true;
				let startDateStr = this.addLocalTimeToDateTime(new Date(this.checkInDate));
				let endDateStr = this.addLocalTimeToDateTime(new Date(this.checkOutDate));
				let opsRequest = {
					"shortTermRentalId" : this.shortTermRentalId,
					"checkInDate" : startDateStr,
					"checkOutDate" : endDateStr
				};
				this.orderDetailService.findNightlyRateOpsNotesDetails(opsRequest)
					.subscribe(
						(res: any) => {
							console.log('findNightlyRateOpsNotesDetails SUCCESS: ' + JSON.stringify(res));
							this.opsNoteDetails.push(res.data.rateLos);
							// this.alertService.success(res, true);
							this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						},
						(err: any) => {
							this.formLoading = false;
							console.log('findNightlyRateOpsNotesDetails FAIL: ' + JSON.stringify(err));
							this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
						},
						() => { this.formLoading = false; });
			} catch (error) {
				this.formLoading = false;
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		if (this.listingType === 2) {
			this.openCompositePasswordDialog((pw) => this.executeRowDeleteWithPassword(event, pw));
		} else {
			this.confirmationService.confirm({
				message: 'Are you sure you want to delete Id# ' + event.orderDetailId + '?',
				header: 'Confirm',
				icon: 'pi pi-exclamation-triangle',
				accept: () => {
					this.formDelete(event);
				},
				reject: () => {
					this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
				}
			});
		}
	}

	private executeRowDeleteWithPassword(event: any, password: string) {
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.orderDetailId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDeleteWithPassword(event, password);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	private formDeleteWithPassword(orderDetail: any, password: string) {
		try {
			console.log('Delete Composite Submitted: ' + JSON.stringify(orderDetail));
			this.formLoading = true;
			this.orderDetailService.delete(orderDetail.orderDetailId, password)
				.subscribe(
					(res: any) => {
						console.log('Composite-Delete SUCCESS: ' + JSON.stringify(res));
						this.orderDetails.splice(this.orderDetails.indexOf(orderDetail), 1);
						this.recordTotal = this.orderDetails.length;
						this.refreshOrder.emit();
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'OrderDetail ' + orderDetail.orderDetailId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Composite-Delete FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'OrderDetail ' + orderDetail.orderDetailId + ' could not be deleted.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-orderDetail-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'orderProductVO.orderProductId', order: 1 });
			}
			if (this.reservationId) {
				// show only orderDetails that are part of reservationId
				let reservationIdFilter = { 'reservationVO.reservationId': { 'value': this.reservationId, 'matchMode': 'in' } };
				Object.assign(event.filters, reservationIdFilter);
			}else{
				this.orderDetails = [];
				return;
			}


			const pageNumber = Math.round(event.first / event.rows);
			this.orderDetailService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.orderDetails = res.data.orderDetails;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.orderDetails = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAddTravelAgentFee() {
		try {
			if (!this.selectedTravelAgent) {
				this.messageService.add({ severity: 'warn', summary: 'Required', detail: 'Please select a travel agent.', life: 3000 });
				return;
			}
			this.computeTravelAgentFee();
			if (!this.taComputedAmt || this.taComputedAmt <= 0) {
				this.messageService.add({ severity: 'warn', summary: 'Required', detail: 'Commission amount must be greater than zero.', life: 3000 });
				return;
			}
			const payload = {
				reservationId: this.reservationId,
				travelAgentProfileId: this.selectedTravelAgent.travelAgentProfileId,
				agentAMT: this.taComputedAmt,
				notes: this.taPrivateNotes || ''
			};
			console.log('addTravelAgentFee post: ' + JSON.stringify(payload));
			this.formLoading = true;
			this.reservationService.addTravelAgentFee(payload)
				.subscribe(
					(res: any) => {
						this.formLoading = false;
						console.log('addTravelAgentFee SUCCESS: ' + JSON.stringify(res));
						this.addTravelAgentFeePopUp = false;
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message || 'Travel agent fee applied.' });
						this.refreshOrder.emit();
						this.refreshTable();
					},
					(err: any) => {
						// Do NOT reset formLoading on error — a 504 means the backend may
						// have already applied the fee. Keep button disabled to block re-submit.
						console.log('addTravelAgentFee FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(orderDetail: OrderDetail) {
		try {
			this.formLoading = true;
			this.orderDetailService.update(orderDetail)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.orderDetails.map((orderDetail, i) => {
							if (orderDetail.orderDetailId === res.data.orderDetail.orderDetailId) {
								this.orderDetails[i] = res.data.orderDetail;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(orderDetail: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(orderDetail));

			this.formLoading = true;
			this.orderDetailService.delete(orderDetail.orderDetailId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.orderDetails.splice(this.orderDetails.indexOf(orderDetail), 1);
						this.recordTotal = this.orderDetails.length;
						this.refreshOrder.emit();
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'OrderDetail ' + orderDetail.orderDetailId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'OrderDetail ' + orderDetail.orderDetailId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {
		if (this.listingType === 2) {
			this.openCompositePasswordDialog((pw) => this.executeOpenFormAdd(pw));
		} else {
			this.executeOpenFormAdd(null);
		}
	}

	private executeOpenFormAdd(password: string | null) {
		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		// To add new orderDetails, use reservationId, orderId to link FK
		let orderDetail = {
			reservationId : this.reservationId,
			orderId : this.orderId
		}

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add Order Detail',
			orderDetail : orderDetail,
			shortTermRentalId :this.shortTermRentalId,
			password: password,
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(OrderDetailComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);
				this.refreshOrder.emit();

					// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addOrderDetailCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(orderDetail: OrderDetail) {
		if (this.listingType === 2) {
			this.openCompositePasswordDialog((pw) => this.executeOpenFormEdit(orderDetail, pw));
		} else {
			this.executeOpenFormEdit(orderDetail, null);
		}
	}

	private executeOpenFormEdit(orderDetail: OrderDetail, password: string | null) {
		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			orderDetail: orderDetail,
			shortTermRentalId :this.shortTermRentalId,
			title: 'Edit Order Detail',
			password: password,
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(OrderDetailComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);
				this.refreshOrder.emit();

					// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateOrderDetailCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);
				// Delete was already executed inside OrderDetailComponent.formDelete() — just refresh
				this.deleteOrderDetailCB(data);
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addOrderDetailCB(orderDetail: OrderDetail) {
			this.refreshTable();
			this.messageService.add({ severity: 'success', summary: 'Success', detail: 'OrderDetail ' + orderDetail.orderDetailId + ' Added', life: 3000 });
	}

	updateOrderDetailCB(orderDetail: OrderDetail) {
		this.refreshTable();
		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'OrderDetail ' + orderDetail.orderDetailId + ' Updated', life: 3000 });
	}

	deleteOrderDetailCB(orderDetail: OrderDetail) {
		this.refreshTable();

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'OrderDetail ' + orderDetail.orderDetailId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.orderDetails ? this.first === (this.orderDetails.length - this.rows) : true; }
	isFirstPage(): boolean { return this.orderDetails ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(orderDetail: any) {
		if (orderDetail?.status) {
			const status = this.statuses.find((e: any) => e.value == orderDetail.status);
			return status.name;
		}
		else {
			return '';
		}
	}
	
	reloadPage() {
		window.location.reload();
	}

	/*********
		 * View Reservation Ledger
		 *
		 */
	viewReservationLedger() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.maxWidth = "95vw";
		dialogConfig.width = "95vw";
		dialogConfig.maxHeight = "87vh";
		dialogConfig.height = "87vh";

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Reservation Ledgers',
			showFilter: true,
			showPagination: false,
			displayClose: false,
			isPopup: true,
			reservationId: this.reservationId

		};
		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(ReservationLedgerListComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		// dialogRef.componentInstance.doAdd.subscribe(
		// 	data => {
		// 		console.log('Dialog output:', data);

		// 		// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
		// 		this.addOrderDetailCB(data);

		// 		// close the dialogBox
		// 		dialogRef.close();
		// 	});
	}

	total(orderDetail: any){
		return (orderDetail?.quantity * orderDetail?.listPrice);
	}

	grandTotal(){
		let total = 0
		this.orderDetails.forEach(orderDetail => {
			total += orderDetail?.total
		});
		return total;
	}

	totalTax(){
		let total = 0
		this.orderDetails.forEach(orderDetail => {
			total += orderDetail?.tax
		});
		return total;
	}
	totalAmount(){
		let total = 0
		this.orderDetails.forEach(orderDetail => {
			total += orderDetail?.subTotal
		});
		return total;
	}
	syncInvoice(){
		this.confirmationService.confirm({
			message: 'Are you sure you want to sync invoice with Streamline? for ReservationId# ' + this.reservationId,
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.reservationService.syncInvoice(this.reservationId)
					.subscribe(
						(res: any) => {
							console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
							// this.alertService.success(res, true);
							this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
							// this.refreshTable();
							this.refreshOrder.emit();
							},
						(err: any) => {
							this.refreshTable();
							this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
						},
						() => { this.formLoading = false; });
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Sync canceled.', life: 1000 });
			}
		});
	}

	syncPayment(){
		this.confirmationService.confirm({
			message: 'Are you sure you want to sync payment with Streamline? for ReservationId# ' + this.reservationId,
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.reservationService.syncPayment(this.reservationId)
					.subscribe(
						(res: any) => {
							console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
							// this.alertService.success(res, true);
							this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
							// this.refreshTable();
							this.refreshOrder.emit();
						},
						(err: any) => {
							this.refreshTable();
							this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
						},
						() => { this.formLoading = false; });
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Sync canceled.', life: 1000 });
			}
		});
	}
	viewOrderDetailTaxes() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.maxWidth = "700px";
		dialogConfig.width = "auto";
		dialogConfig.maxHeight = "auto";
		dialogConfig.height = "auto";

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Reservation Ledgers',
			showFilter: false,
			showPagination: false,
			displayClose: false,
			reservationId: this.reservationId,
			orderDetails: this.orderDetails,

		};
		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(OrderDetailTaxListComponent, dialogConfig);

		//to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.refreshOrder.emit();

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.refreshOrder.emit();

				// close the dialogBox
				dialogRef.close();
			});
	}
	// Its used to update reservation order details when, add/update or delete order products from reservation
	refreshTable(){this.loadLazy(this.lazyLoadEvent);}

	// this is used to regenerate invoice
	openPopUpReGenerateInvoice(){
		this.amountReceived = null;
		this.reGenerateInvoicePopUp = true;
	}

	openPopUpAddTravelAgentFee(){
		this.buildForm();
		// Reset dialog state
		this.selectedTravelAgent = null;
		this.taFeeMode = 'pct';
		this.taFeeBase = 'grandTotal';
		this.taAgentPCT = 0;
		this.taAgentAMT = 0;
		this.taPrivateNotes = '';
		this.taComputedAmt = 0;
		// Check for existing TRAVEL_AGENT_FEE line item
		this.existingTravelAgentFee = (this.orderDetails || []).find(
			(d: any) => d.name && d.name.toUpperCase().includes('TRAVEL_AGENT_FEE')
		) || null;
		// Load agent profiles if not already loaded
		if (!this.travelAgentProfiles || this.travelAgentProfiles.length === 0) {
			this.loadTravelAgentProfiles();
		}
		this.addTravelAgentFeePopUp = true;
	}

	loadTravelAgentProfiles() {
		this.travelAgentProfilesLoading = true;
		this.travelAgentProfileService.findAll().pipe(first()).subscribe(
			(res: any) => {
				this.travelAgentProfiles = res.data?.travelAgentProfiles || [];
			},
			(err: any) => {
				console.log('loadTravelAgentProfiles FAIL: ' + JSON.stringify(err));
				this.travelAgentProfiles = [];
			},
			() => { this.travelAgentProfilesLoading = false; }
		);
	}

	onTravelAgentSelect(agent: any) {
		this.selectedTravelAgent = agent;
		if (agent && agent.defaultCommissionPCT != null) {
			// defaultCommissionPCT is stored as a decimal (e.g. 0.10 = 10%)
			this.taAgentPCT = +(agent.defaultCommissionPCT * 100).toFixed(2);
		} else {
			this.taAgentPCT = 0;
		}
		this.computeTravelAgentFee();
	}

	computeTravelAgentFee() {
		if (this.taFeeMode === 'pct') {
			const base = this.getTaFeeBase();
			this.taComputedAmt = +(base * (this.taAgentPCT / 100)).toFixed(2);
			this.taAgentAMT = this.taComputedAmt;
		} else {
			this.taComputedAmt = this.taAgentAMT;
		}
	}

	getTaFeeBase(): number {
		if (this.taFeeBase === 'subTotal') {
			return this.totalAmount();
		} else if (this.taFeeBase === 'nightlyOnly') {
			// Find nightly rate line item total
			const nightly = (this.orderDetails || []).find(
				(d: any) => d.name && d.name.toLowerCase().includes('night')
			);
			return nightly ? (nightly.total || 0) : this.grandTotal();
		}
		// grandTotal (default)
		return this.grandTotal();
	}

	getTaNights(): number {
		const checkIn = this.checkInDate ? moment(this.checkInDate) : null;
		const checkOut = this.checkOutDate ? moment(this.checkOutDate) : null;
		if (checkIn && checkOut) {
			return checkOut.diff(checkIn, 'days');
		}
		return 1;
	}

	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	reGenerateInvoice() {
		try {
			this.formLoading = true;
			const data = {
				amountReceived: this.amountReceived,
				reservationId: this.reservationId
			}
			this.reservationService.reGenerateInvoice(data)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						// this.refreshTable();
						this.refreshOrder.emit();
						this.formLoading = false;
						this.reGenerateInvoicePopUp = false;
						this.messageService.add({ severity: 'success', summary: 'Success', detail: "Invoice regenerate successfully" });
					},
					(err: any) => {
						// Do NOT reset formLoading on error — a 504 means the backend may
						// have already regenerated the invoice. Keep button disabled to block re-submit.
						console.log('ReGenerate Invoice FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => {  });
		} catch (error) {
			this.formLoading = false;
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	reGenerateOtaInvoice() {
		try {
			this.confirmationService.confirm({
				message: 'Are you sure you want to reGenerate Rental-United reservation invoice? for ReservationId# ' + this.reservationId,
				header: 'Confirm',
				icon: 'pi pi-exclamation-triangle',
				accept: () => {
					this.formLoading = true;
					this.reservationService.reGenerateOtaInvoice(this.reservationId)
						.subscribe(
							(res: any) => {
								console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
								// this.refreshTable();
								this.refreshOrder.emit();
								this.formLoading = false;
								this.messageService.add({ severity: 'success', summary: 'Success', detail: "Invoice regenerate successfully" });
							},
							(err: any) => {
								// Do NOT reset formLoading on error — a 504 means the backend may
								// have already regenerated the invoice. Keep button disabled to block re-submit.
								console.log('ReGenerate Invoice FAIL: ' + JSON.stringify(err));
								this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
							},
							() => {  });
				},
				reject: () => {
					this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Sync canceled.', life: 1000 });
				}
			});


		} catch (error) {
			this.formLoading = false;
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/**
   * Redirect to Property page on YM filtered by current dialog property
   * @param opsNoteDetail 
   * @param defaultTabIndx 
   */
	redirectToProperty(opsNoteDetail:any, defaultTabIndx: any)
	{
	  let baseUrl = '/property-config/'+opsNoteDetail.propertyId;
	  if(opsNoteDetail.rateBucketId)
	  {
		  baseUrl = baseUrl + '/' + opsNoteDetail.rateBucketId;
	  }
	  
	  baseUrl = baseUrl + '/' + defaultTabIndx;
	  //Rate Season
	  if(defaultTabIndx == 4)
	  {
		  let checkInDate = opsNoteDetail.checkInDate;
		  let checkOutDate = opsNoteDetail.checkOutDate;
		  if(checkInDate == null)
		  {
			  checkInDate = moment.utc(this.checkInDate).format('YYYY-MM-DD');
		  }
		  
		  if(checkOutDate == null)
		  {
			  //End date creates timezone issue hence using this method to remove timezone
			//   let searchedEndDate = this.addLocalTimeToDateTime(this.checkOutDate);
			  checkOutDate = moment.utc(this.checkOutDate).format('YYYY-MM-DD');
		  }
		  baseUrl = baseUrl + '/' + checkInDate + '/' + checkOutDate;
	  }
	  
	  	const url = this.router.serializeUrl(
		  this.router.createUrlTree([baseUrl])
		);
		window.open(url, '_blank');
	}

	/**
	 * Add time plus local time GMT hours as http request change time to UTC time
	 * @param datetime 
	 * @returns 
	 */
	addLocalTimeToDateTime(datetime) {
		return new Date(datetime.getTime() - (datetime.getTimezoneOffset() * 60000));
	}

	private buildForm() {
		this.formTravelAgent = this.formBuilder.group({
			reservationId: [this.reservationId],
		});
	}
	public exportAsExcelFile($event): void {
		let data = [];
		try {
			this.orderDetails.forEach((e) => {
				let row = {
					name: e.name,
					quantity: e.quantity,
					listPrice: e.listPrice,
					listPriceAdjustmentAmount: e.listPriceAdjustmentAmount,
					subTotal: e.subTotal,
					tax: e.tax,
					total: e.total,
				};

				data.push(row);
				e.orderDetailTaxes?.forEach((tax) => {
					let row = {
						name:  tax.name + " (" + tax?.taxPCT+")",
						quantity: '',
						listPrice: '',
						listPriceAdjustmentAmount: '',
						subTotal: '',
						tax: tax.taxAmount,
						total: '',
					};
					data.push(row);
				});
			});
		}catch (e){

		}
		this.importExportComponent.exporData($event, data, "ReservationInvoice#"+this.reservationId);
	}

	openCompositePasswordDialog(action: (password: string) => void) {
		this.compositePasswordValue = '';
		this.compositePasswordError = '';
		this.pendingCompositeAction = action;
		this.compositePasswordDialogVisible = true;
	}

	onCompositePasswordConfirm() {
		const password = this.compositePasswordValue;
		this.compositePasswordDialogVisible = false;
		this.compositePasswordError = '';
		if (this.pendingCompositeAction) {
			this.pendingCompositeAction(password);
			this.pendingCompositeAction = null;
		}
	}

	onCompositePasswordCancel() {
		this.compositePasswordDialogVisible = false;
		this.compositePasswordValue = '';
		this.compositePasswordError = '';
		this.pendingCompositeAction = null;
	}

	onDeleteByReservationId(){
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete all invoice items? ',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				try {
					this.exportAsExcelFile("pdf")
					// stop here if form is invalid
					this.formLoading = true;
					this.orderDetailService.deleteAllByReservationId(this.reservationId)
						.subscribe(
							(res: any) => {
								this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'ReservationInvoice Deleted for reservation#'+this.reservationId, life: 3000 });
								this.loadLazy(this.lazyLoadEvent);
							},
							(err: any) => {
								this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'Reservation#' + this.reservationId+ ' invoice could not be deleted.', life: 3000 });
							},
							() => { this.formLoading = false; });
				} catch (error) {
					console.log('Form Invalid: ' + JSON.stringify(error));
					this.alertService.error(error);
				}
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}
}
